<template>
  <div class="quote__invent">
    <p>{{ item.typeName }}</p>
    <ul>
      <li>{{ item.description }}</li>
      <li v-if="item.serialNumber">{{$t('qic_quote_item_serial_number')}}: {{ item.serialNumber }}</li>
      <li v-if="item.valueQAR">{{$t('qic_quote_item_value')}}: <span class="rtlQar">{{$t('qic_qar')}} {{ item.valueQAR }}</span></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'QuoteInsuredItem',
  props: {
    item: { type: Object }
  },
  mounted () {}
}
</script>
